module.exports = __webpack_public_path__ + "img/icon-address-delete.40c8a04.svg";